<app-generic-border-template *ngIf="hasPursuitItems" [header]="'PURSUITS'">
  <div *ngFor="let pursuitItem of pursuitItems; let i = index; trackBy: trackByIndex">
    <app-chase-detail-info-pursuit-item [pursuitItem]="pursuitItem"></app-chase-detail-info-pursuit-item>
  </div>
</app-generic-border-template>